import React from 'react';

const stickers = {
  main: '/stickers/main.tgs',
  success: '/stickers/success.tgs',
  loading: '/stickers/loading.tgs',
};

function Sticker({ type = 'main', size = 180 }) {
  return (
    <div style={{ 
      width: size, 
      height: size, 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto'
    }}>
      <tgs-player
        src={stickers[type] || stickers.main}
        style={{ width: '100%', height: '100%' }}
        loop
        autoplay
      />
    </div>
  );
}

export default Sticker; 